<template lang="html">
    <section class="animated-bar">
        <div v-for="n in 5" :key="n" class="animated-image">
            <img :src="imageUrls[n - 1]" alt="" class="current-image" />
            <img
                :src="nextImageUrls[n - 1]"
                alt=""
                class="next-image"
                :data-active="transitioning ? 'true' : 'false'"
            />
        </div>
    </section>
</template>

<script>
export default {
    name: "AnimatedBar",
    data() {
        return {
            imageCounts: [29, 40, 23, 23, 21],
            imageUrls: [],
            nextImageUrls: [],
            transitioning: false,
            lastSetIndex: null,
        };
    },
    mounted() {
        this.preloadImages();
        this.startImageRotation();
    },
    methods: {
        preloadImages() {
            const imageList = new Set();

            this.imageCounts.forEach((imageCount, set) => {
                for (let i = 1; i <= imageCount; i++) {
                    const imageIndex = String(i).padStart(3, "0");
                    const imageUrl = `/images/home/set-${
                        set + 1
                    }-${imageIndex}.webp`;
                    imageList.add(imageUrl);
                }
            });

            imageList.forEach((src) => {
                const img = new Image();
                img.src = src;
            });
        },
        startImageRotation() {
            this.imageUrls = this.getStartingSet();

            setInterval(() => {
                this.nextImageUrls = this.replaceRandomImage();
                this.transitioning = true;

                setTimeout(() => {
                    this.transitioning = false;
                    this.imageUrls = this.nextImageUrls;
                }, 400);
            }, 3000);

            // setInterval(() => {
            //     this.nextImageUrls = this.getRandomImages(this.imageUrls);
            //     this.transitioning = true;
            //     setTimeout(() => {
            //         this.transitioning = false;
            //         this.imageUrls = this.nextImageUrls;
            //     }, 700);
            // }, 5000);
        },
        getStartingSet() {
            const imageUrls = [];

            this.imageCounts.forEach((imageCount, set) => {
                const imageIndex = String(
                    Math.floor(Math.random() * imageCount) + 1
                ).padStart(3, "0");
                const imageUrl = `/images/home/set-${
                    set + 1
                }-${imageIndex}.webp`;

                imageUrls.push(imageUrl);
            });

            return imageUrls;
        },
        replaceRandomImage() {
            let setIndex, imageIndex;

            // Ensure the next set is different from the last set
            while (setIndex === undefined || setIndex === this.lastSetIndex) {
                setIndex = Math.floor(Math.random() * this.imageUrls.length);
            }

            this.lastSetIndex = setIndex;

            // Get the image count for the set
            const imageCount = this.imageCounts[setIndex];

            // Get the next image index
            const oldImageIndex = this.imageUrls[setIndex]
                .split("-")[2]
                .split(".")[0];

            while (imageIndex === undefined || imageIndex === oldImageIndex) {
                imageIndex = String(
                    Math.floor(Math.random() * imageCount) + 1
                ).padStart(3, "0");
            }

            // Set the new image URL
            const imageUrl = `/images/home/set-${
                setIndex + 1
            }-${imageIndex}.webp`;

            const nextImageUrls = this.imageUrls.slice();

            nextImageUrls[setIndex] = imageUrl;

            return nextImageUrls;
        },
    },
};
</script>

<style scoped>
.animated-bar {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
}

.animated-image {
    display: grid;
    height: 10rem;

    &:nth-child(1) {
        grid-column: span 2;
        background-color: #909090;
    }
    &:nth-child(2) {
        grid-column: span 2;
        background-color: #a0a0a0;
    }
    &:nth-child(3) {
        grid-column: span 2;
        background-color: #b0b0b0;
    }
    &:nth-child(4) {
        grid-column: span 3;
        background-color: #c0c0c0;
    }
    &:nth-child(5) {
        grid-column: span 3;
        background-color: #d0d0d0;
    }
}

.animated-image img {
    grid-row: 1;
    grid-column: 1;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.next-image {
    opacity: 0;
    transition: opacity 0.4s;
}

.next-image[data-active="true"] {
    opacity: 1;
}

@media (min-width: 480px) {
    .animated-bar {
        grid-template-columns: repeat(5, 1fr);
    }

    .animated-image {
        grid-column: unset !important;
    }
}
</style>
